/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryRoleSetupProposedRole,
  DirectoryRoleSetupProposedRole$inboundSchema,
} from "./directoryrolesetupproposedrole.js";
import {
  DirectoryRoleSetupSource,
  DirectoryRoleSetupSource$inboundSchema,
} from "./directoryrolesetupsource.js";

export type DirectoryRoleSetupPreviewItem = {
  /**
   * People with a live directory profile that matches the source, counted once per email address, so someone with profiles in two directories counts once and a profile with no email is not counted. These are directory people, not organization members or role members.
   */
  directoryPeople: number;
  /**
   * Roles the source already maps to. Empty for an unmapped source.
   */
  existingRoleUrns: Array<string>;
  /**
   * The suggested role set. For a mapped source this is its current set; for an unmapped source, one reused or new role.
   */
  proposedRoles: Array<DirectoryRoleSetupProposedRole>;
  source: DirectoryRoleSetupSource;
  /**
   * The group name, or key=value for an attribute value.
   */
  sourceName: string;
  /**
   * Opaque version of the source and its current mappings. Send it back with applyDirectoryRoleSetup.
   */
  version: string;
};

/** @internal */
export const DirectoryRoleSetupPreviewItem$inboundSchema: z.ZodMiniType<
  DirectoryRoleSetupPreviewItem,
  unknown
> = z.pipe(
  z.object({
    directory_people: z.int(),
    existing_role_urns: z.array(z.string()),
    proposed_roles: z.array(DirectoryRoleSetupProposedRole$inboundSchema),
    source: DirectoryRoleSetupSource$inboundSchema,
    source_name: z.string(),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "directory_people": "directoryPeople",
      "existing_role_urns": "existingRoleUrns",
      "proposed_roles": "proposedRoles",
      "source_name": "sourceName",
    });
  }),
);

export function directoryRoleSetupPreviewItemFromJSON(
  jsonString: string,
): SafeParseResult<DirectoryRoleSetupPreviewItem, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DirectoryRoleSetupPreviewItem$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DirectoryRoleSetupPreviewItem' from JSON`,
  );
}
